import React from 'react';
import styled from 'styled-components';

import welcomeLogo from '../assets/imgs/welcome-logo.png';
import rabbitShadow from '../assets/imgs/rabbit-shadow.png';
import { isEnterprise } from '../config';

const WelcomePanel = () => (
  <div className="bg-primary h-full flex flex-col items-center justify-between">
    <img
      src={isEnterprise ? '/enterprise-logo.png' : welcomeLogo}
      alt="welcome_logo"
    />
    <img src={rabbitShadow} alt="logo" />
  </div>
);

export default WelcomePanel;
